'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCreate$002dPolicy$002dPage$0024 from "./presto.-Create-Policy-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002451 from "./presto.-Presto-Router$$anon$51.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$50() {
  this.bks = null;
  this.bkk = null;
  this.bkl = false;
  this.bkt = null;
  this.bku = false;
  this.bkx = null;
  this.bkq = null;
  this.bkr = false;
  this.bkm = null;
  this.bkn = false;
  this.bko = null;
  this.bkp = false;
  this.bkv = false;
  this.bkw = false;
  this.bks = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bkx = "CreatePolicyPage";
}
export { $c_Lpresto_PrestoRouter$$anon$50 as $c_Lpresto_PrestoRouter$$anon$50 };
$p = $c_Lpresto_PrestoRouter$$anon$50.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$50;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$50() {
}
export { $h_Lpresto_PrestoRouter$$anon$50 as $h_Lpresto_PrestoRouter$$anon$50 };
$h_Lpresto_PrestoRouter$$anon$50.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bks;
});
$p.M = (function() {
  if ((!this.bkl)) {
    this.bkk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bkl = true;
  }
  return this.bkk;
});
$p.O = (function() {
  if ((!this.bku)) {
    this.bkt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bku = true;
  }
  return this.bkt;
});
$p.D = (function() {
  return this.bkx;
});
$p.t = (function() {
  if ((!this.bkr)) {
    this.bkq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkr = true;
  }
  return this.bkq;
});
$p.N = (function() {
  if ((!this.bkn)) {
    this.bkm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkn = true;
  }
  return this.bkm;
});
$p.Q = (function() {
  if ((!this.bkp)) {
    this.bko = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002451.$c_Lpresto_PrestoRouter$$anon$51();
    this.bkp = true;
  }
  return this.bko;
});
$p.v = (function() {
  if ((!this.bkw)) {
    this.bkv = false;
    this.bkw = true;
  }
  return this.bkv;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee391) => ((p) => \u03b4scrutinee391))($j_presto$002e$002dCreate$002dPolicy$002dPage$0024.$m_Lpresto_CreatePolicyPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$50, "presto.PrestoRouter$$anon$50", ({
  Oq: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$50 as $d_Lpresto_PrestoRouter$$anon$50 };
//# sourceMappingURL=presto.-Presto-Router$$anon$50.js.map
